<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div :style="`height: ${detailHeight}px; overflow-y: auto`">
        <t-form
          ref="docTableData"
          name="docTableData"
          :data="docTableData"
          label-width="100px"
          label-position="right"
          domain="docTableData"
        >
          <t-collapse v-model="activeNames" accordion>
            <!-- 見積書用 -->
            <t-collapse-item title="見積書用" name="orderBasic1" v-if="false">
              <div style="padding: 0 15px 0 15px; min-height: 100px">
                <t-row>
                  <t-col :span="11">
                    <!-- 件名 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsEstiName')"
                      prop="dsEstiName"
                    >
                      <t-input
                        v-model="docTableData.dsEstiName"
                        maxLength="40"
                        clearable
                        class="inputStyle"
                      >
                      </t-input>
                    </t-form-item>
                  </t-col>
                  <t-col :span="11">
                    <!-- 納期 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsEstiDueDate')"
                      prop="dsEstiDueDate"
                    >
                      <t-input
                        v-model="docTableData.dsEstiDueDate"
                        maxLength="50"
                        clearable
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>
                  <t-col :span="11">
                    <!-- お支払条件 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsEstiPayTerms')"
                      prop="dsEstiPayTerms"
                    >
                      <t-input
                        v-model="docTableData.dsEstiPayTerms"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>
                  <t-col :span="11">
                    <!-- 有効期限 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsEstiDeadline')"
                      prop="dsEstiDeadline"
                    >
                      <t-input
                        v-model="docTableData.dsEstiDeadline"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>
                  <t-col :span="22">
                    <!-- 備考 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsEstiRemarks')"
                      prop="dsEstiRemarks"
                    >
                      <textarea
                        v-model="docTableData.dsEstiRemarks"
                        rows="4"
                        maxLength="500"
                        placeholder="请输入内容"
                        show-word-limit
                      ></textarea>
                    </t-form-item>
                  </t-col>
                </t-row>
              </div>
            </t-collapse-item>

            <!-- 采购订单用 -->
            <t-collapse-item title="采购订单用" name="orderBasic2">
              <div style="padding: 0 15px 0 15px; min-height: 100px">
                <t-row>
                  <t-col :span="11">
                    <!-- 交货方式 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProShippingMethod')"
                      prop="dsProShippingMethod"
                    >
                      <t-input
                        v-model="docTableData.dsProShippingMethod"
                        maxLength="40"
                        class="inputStyle"
                      >
                      </t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 税率(%) -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProTaxRate')"
                      prop="dsProTaxRate"
                    >
                      <t-input
                        v-model="docTableData.dsProTaxRate"
                        maxLength="5"
                        class="inputStyle"
                        @blur="dataProcess()"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 发票类型 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProInvoiceCategory')"
                      prop="dsProInvoiceCategory"
                    >
                      <t-input
                        v-model="docTableData.dsProInvoiceCategory"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 付款约定 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProPayAgreement')"
                      prop="dsProPayAgreement"
                    >
                      <t-input
                        v-model="docTableData.dsProPayAgreement"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>
                  <t-col :span="11">
                    <!-- 支付方式 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProPayMethod')"
                      prop="dsProPayMethod"
                    >
                      <t-input
                        v-model="docTableData.dsProPayMethod"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 所属项目 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProBelongProject')"
                      prop="dsProBelongProject"
                    >
                      <t-input
                        v-model="docTableData.dsProBelongProject"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="22">
                    <!-- 其他约定 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProOtherRule')"
                      prop="dsProOtherRule"
                    >
                      <t-input
                        v-model="docTableData.dsProOtherRule"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="22">
                    <!-- 備考 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsProRemarks')"
                      prop="dsProRemarks"
                    >
                      <div>
                        <textarea
                          v-model="docTableData.dsProRemarks"
                          rows="4"
                          maxLength="500"
                          placeholder="请输入内容"
                        ></textarea>
                      </div>
                    </t-form-item>
                  </t-col>
                </t-row>
              </div>
            </t-collapse-item>

            <!-- 注文書用 -->
            <t-collapse-item title="発注書用" name="orderBasic3">
              <div style="padding: 0 15px 0 15px; min-height: 100px">
                <t-row>
                  <t-col :span="11">
                    <!-- 注文書_件名 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsOdName')"
                      prop="dsOdName"
                    >
                      <t-input
                        v-model="docTableData.dsOdName"
                        maxLength="40"
                        class="inputStyle"
                      >
                      </t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 注文書_納期-->
                    <t-form-item
                      :label="$t('resource.documentSet.dsOdDueDate')"
                      prop="dsOdDueDate"
                    >
                      <t-input
                        v-model="docTableData.dsOdDueDate"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 注文書_お支払条件 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsOdPayTerms')"
                      prop="dsOdPayTerms"
                    >
                      <t-input
                        v-model="docTableData.dsOdPayTerms"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 注文書_納入方法 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsOdDeliveryMethod')"
                      prop="dsOdDeliveryMethod"
                    >
                      <t-input
                        v-model="docTableData.dsOdDeliveryMethod"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>
                  <t-col :span="11">
                    <!-- 注文書_送り先 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsOdForwarding')"
                      prop="dsOdForwarding"
                    >
                      <t-input
                        v-model="docTableData.dsOdForwarding"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="11">
                    <!-- 注文書_貴社見積No. -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsOdQuoteNo')"
                      prop="dsOdQuoteNo"
                    >
                      <t-input
                        v-model="docTableData.dsOdQuoteNo"
                        maxLength="50"
                        class="inputStyle"
                      ></t-input>
                    </t-form-item>
                  </t-col>

                  <t-col :span="22">
                    <!-- 注文書_備考 -->
                    <t-form-item
                      :label="$t('resource.documentSet.dsOdRemarks')"
                      prop="dsOdRemarks"
                    >
                      <div>
                        <textarea
                          v-model="docTableData.dsOdRemarks"
                          rows="4"
                          maxLength="500"
                          placeholder="请输入内容"
                        ></textarea>
                      </div>
                    </t-form-item>
                  </t-col>
                </t-row>
              </div>
            </t-collapse-item>

            <!-- 請求書用 -->
            <t-collapse-item title="請求書用" name="requestBook">
              <div style="padding: 0 15px 0 15px; min-height: 50px">
                <t-row>
                  <t-col :span="11">
                    <!-- 登録番号 -->
                    <t-form-item label="登録番号" prop="loginNo">
                      <t-input
                        v-model="docTableData.dsReqLoginNo"
                        maxLength="30"
                        class="inputStyle"
                      >
                      </t-input>
                    </t-form-item>
                  </t-col>
                </t-row>
              </div>
            </t-collapse-item>
          </t-collapse>
        </t-form>
      </div>

      <!-- ボタン -->
      <div class="right" :style="{ height: bottomHeight + 'px' }">
        <!-- 確定ボタン -->
        <t-button
          round
          type="warning"
          class="dialogButton_confirm_120_40"
          ref="confirmBtn"
          @click="confirmClick()"
        >
          <i class="el-icon-check"></i>
          {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
        >
      </div>
    </t-card>
  </div>
</template>

<script>
import { t } from "@/locales";
import { EditDocSetInfo, GetDocSetInfoData } from "@/services/documentSet";
import {
  getDialogContentHeight,
  getDialogContentHeightComm,
  numberFormat,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message } from "@tellus/component";
export default {
  data() {
    return {
      //明細情報のheight
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
      // 課題_納期分割機能の追加
      // detailHeight: getDialogContentHeight(window.innerHeight, 0, 0, 0),
      detailHeight: getDialogContentHeightComm(window.innerHeight, 0, 0, 0),
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
      //maxheight: window.innerHeight - 100 - 10 - DIALOG_LINE_HEIGHT,

      textarea: "",
      showFlag: false,
      docTableData: {},
      activeNames: ["1"],
    };
  },

  mounted() {
    //画面初期化
    this.init();
  },
  methods: {
    // 画面初期化
    init() {
      this.showFlag = true;
      //共通設定情報の取得
      this.infoInit();

      //テーブルの高さを監視する
      window.addEventListener("resize", this.handleResize);
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = window.innerHeight - 100 - 10 - DIALOG_LINE_HEIGHT; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6  - 291.5
    },

    infoInit() {
      //共通設定情報の取得
      GetDocSetInfoData()
        .then((res) => {
          this.showFlag = false;
          if (Array.isArray(res) && res.length > 0) {
            this.docTableData = res[0];
          }
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });
    },

    //データの処理
    dataProcess() {
      //提成率(%)
      this.docTableData.dsProTaxRate = numberFormat(
        this.docTableData.dsProTaxRate,
        "0.00"
      );

      if (this.docTableData.dsProTaxRate > 99.99) {
        this.docTableData.dsProTaxRate = 99.99;
      } else if (this.docTableData.dsProTaxRate < 0) {
        this.docTableData.dsProTaxRate = 0;
      } else {
        this.docTableData.dsProTaxRate = this.docTableData.dsProTaxRate;
      }
    },

    // 編集
    confirmClick() {
      EditDocSetInfo(this.docTableData)
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        })
        .finally(() => {
          this.init();
        });

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },
  },
};
</script>

<style scoped lang="scss">
textarea {
  width: 100%;
  border-radius: 4px;
  display: inline-block;
  padding-left: 15px;
  color: #6a6767 !important;
  border: 1px solid #dcdddd;
  resize: none; /* 防止用户调整大小 */
  box-sizing: border-box; /* 确保padding和border不会影响实际高度 */
}

textarea:focus {
  outline: none; /* 首先移除默认的轮廓 */
  border: 1px solid #74b5ff; /* 设置聚焦时的边框颜色 */
}

textarea:focus-visible {
  outline: 1px solid #dcdddd;
}
</style>
